import * as navigation from 'Navigation';
import {getLegacyRequestObjectName} from 'requests/RequestConstants';

export default class RequestDetailsTabState extends navigation.TabState {
  defaults(): navigation.TabStateDefaults {
    return {
      ...super.defaults(),
      title: getLegacyRequestObjectName(),
      closeable: false,
      preferenceKey: 'request-details',
    };
  }
}
